module.exports = __webpack_public_path__ + "assets/img/inex.064d3dae.png";